import React from 'react';
import { TextField } from '@material-ui/core';

import './TextBox.scss';

export default function TextBox(props) {
  const { value, onChange, isDisabled, label, rows, multiline, style, } = props;

  const labelProps = label ? label : false
  const isDisabledProps = isDisabled ? isDisabled : false
  const rowsProps = rows ? rows : ''
  const multilineProps = multiline ? true : false
  const styleProps = style ? style : undefined

  return (
    <TextField
      style={styleProps}
      className="textBox"
      label={labelProps}
      value={value}
      onChange={onChange}
      variant="outlined"
      size="small"
      // size="medium"//縦に大きい
      disabled={isDisabledProps}
      rows={rowsProps}
      multiline={multilineProps}
      color="primary"
    />
  );
}

